<template>
  <article class="bic-list__bic-item bic-item" v-bind:class="{ 'bic-item--expanded': expanded }">
    
    <!-- always displayed -->
    <div class="bic-item__header">
      <input class="bic-item__select" type="checkbox" :checked="selected" v-on:change="toggleSelected" />
      <h3 class="bic-item__title">{{ item.desc }}</h3>
      
      <div class="bic-item__subtitle u-clearfix">
        <button class="bic-item__help" v-on:click="toggleTooltip">?</button>
        <div class="bic-item__code-label">Business Industry Code:<span class="bic-item__code"> {{ item.code }}</span></div>
        <div class="bic-item__help-popup help-popup" v-bind:class="{ 'help-popup--hidden': !showHelp }">
          <button class="help-popup__close-button" v-on:click="toggleTooltip">'</button>
          <div class="help-popup__content">
            This code is used by ACC, Inland Revenue and Statistics NZ. Provide this code eg when you file tax returns or register for GST.
          </div>
        </div>
      </div>
    </div>
    
    <!-- always displayed -->
    <div v-if="item.important" class="bic-item__important">{{ item.important }}</div>

    <!-- DEFINITION -->
    <!-- displayed by default on Desktop only -->
    <div v-if="item.definition" class="bic-item__definition" v-html="item.definition"></div>
    <div v-if="!item.definition" class="bic-item__definition bic-item__definition--noDefinition">Click 'More' to see Classification Unit and ANZSIC codes.</div>

    <!-- this section is hidden by default - toggled by the more button -->
    <div class="bic-item__additional-info">

        <!-- HISTORY -->
        <div v-if="item.historyYear" class="bic-item__section">
          <b>Valid from:</b><br/>
          <div class="bic-item__section-content">This code is only valid for registrations after 1 April {{ item.historyYear }} and tax returns for {{ item.historyYear }} onwards.</div>
          <div v-if="item.historyBicId" class="bic-item__section-content">For earlier years use {{ item.historyBic.code }} {{ item.historyBic.desc }}</div>
        </div>

        <!-- REFERENCES - OTHER CODES -->
        <div v-if="item.bicrefs && item.bicrefs.length" class="bic-item__section">
          <b>Other codes to consider:</b>         
          <ul class="bicrefs">
            <li v-for="bicref in item.bicrefs" v-bind:key="bicref.id">
              <BicItemRefSplit 
                :bicref="bicref" 
                :getAlternateBicForSource="getAlternateBicForSource"
              />
            </li>
          </ul>
        </div>

        <!-- CLASSIFICATION UNIT (CU) -->
        <div class="bic-item__section">
            <div class="bic-item__section-header">Classification Unit (CU): {{ item.cu.code }}</div>
            <div class="bic-item__section-header">{{ item.cu.desc }}</div>
            <div class="bic-item__section-content">This is used by ACC to calculate your levies. <a id target="_blank" href="https://www.acc.co.nz/Calculator" class="external">Calculate your levies</a></div>
        </div>

        <div class="bic-item__section">
          <div class="bic-item__section-header">ANZSIC: {{ item.anzsic.code }}</div>
          <div class="bic-item__section-header">{{ item.anzsic.desc }}</div>
          <div class="bic-item__section-content">Statistics NZ uses this to compile and analyse industry statistics.</div>
        </div>
    </div> <!-- end bic-item__additional-info -->
    
    <button class="bic-item__more" v-on:click="toggleExpanded" data-gtm-category="BicItem expand" data-gtm-action="Expand Cards" :data-gtm-label="label">
      <span class="bic-item__more-label">More  </span>
    </button>

  </article>
</template>

<script>
  import Vue from 'vue';
  import BicItemRefSplit from './BicItemRefSplit.vue';

  export default Vue.component('BicItem', {
    props: {
      item: Object,
      selected: Boolean,
      showHelp: Boolean,
      addToWatchlist: Function,
      removeFromWatchlist: Function,
      toggleBicsHelp: Function,
      getAlternateBicForSource: Function,
    },
    data: function() {
      return {
        expanded: false,
      };
    },
    computed: {
      label: function() {
        return `${this.item.code} - ${this.item.desc}`;
      }
    },
    methods: {
      toggleExpanded: function () {
        return this.expanded = !this.expanded;
      },
      toggleSelected: function (event) {
        if (event.target.checked) {
          this.addToWatchlist();
        } else {
          this.removeFromWatchlist();
        }
      },
      toggleTooltip: function (event) {
        this.toggleBicsHelp();
        // this.toggleBicsHelp({ code: this.item.code });
      },
    }
  });
</script>